module.exports = __webpack_public_path__ + "static/img/homeChange1.bb7c681f.png";